import { render, staticRenderFns } from "./PersonalLink.vue?vue&type=template&id=c1cb419e&"
import script from "./PersonalLink.vue?vue&type=script&lang=js&"
export * from "./PersonalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports